import React from "react";
import * as PropTypes from "prop-types";
import  Grid  from "@mui/material/Grid2";
import { clickPanel } from "../engine/engineSelector.js";
import { DEFAULT_CUSTOM_CHART_KEY } from "../../../constants/trendGraph/charts.js";
import { AddButton } from "../../common/addButton.jsx";
import { Box, Button, Stack, Tooltip } from '@mui/material';

const buttonDesign = {
  alignItems: "left",
  justifyContent: "flex-start",
  display: "flex",
  width: "130px",
  "&:focus": {
    outline: "none",
  },
};

const buttonTextDesign = {
  color: "#ffffff",
  fontFamily: "Inter",
  fontSize: "11px",
  fontWeight: "300",
  fontStretch: "normal",
  fontStyle: "normal",
  lineHeight: "normal",
  letterSpacing: "normal",
  textTransform: "none",
  opacity: "100%",
  justifyContent: "flex-start",
  overflow: "hidden",
  whiteSpace: "nowrap",
  textOverflow: "ellipsis",
};

const styles = {
  dataList: {
    "& p": {
      MozUserSelect: "none",
      WebkitUserSelect: "none",
      msUserSelect: "none",
    },
  },
  trueButton: {
    ...buttonDesign,
    "& span": {
      ...buttonTextDesign,
      color: "#19b2ab",
      fontWeight: "600",
    },
    borderRadius: 0,
    padding: "4px 8px",
    minWidth: "0px",
  },
  falseButton: {
    ...buttonDesign,
    "& span": {
      ...buttonTextDesign,
      color: "#ffffff",
      "&:hover": {
        opacity: "70%",
      },
    },
    padding: "4px 8px",
    minWidth: "0px",
  },
  addButton: {
    width: "17px",
    height: "17px",
    border: "1px solid white",
    borderRadius: "5px",
    "-webkit-transform": "rotate(45deg)",
    "-moz-transform": "rotate(45deg)",
    "-o-transform": "rotate(45deg)",
    "-ms-transform": "rotate(45deg)",
    transform: "rotate(45deg)",
  },
};

export const CustomGraphSelector = React.memo((props) => {
  const {
    chartList,
    selectedChart,
    setSelectedChart,
    isCreateCustomCharts,
    setIsCreateCustomCharts,
    customChartTitle,
  } = props;
  const displayChartListLength = chartList?.length + (isCreateCustomCharts ? 1 : 0);
  const displayChartList = () => {
    return (
      <Stack direction={"row"} sx={{ width: "100%", flexWrap: "wrap", padding: "0 12px"}}>
        {chartList ? (
          <>
            {chartList.map((chart, i) => (
              <Tooltip key={`tooltip-${chart.id}`} title={chart.name} placement="bottom-start">
                <Button
                  onClick={() => clickPanel(chart.id, null, setSelectedChart)}
                  component="button"
                  sx={chart.id === selectedChart ? styles.trueButton : styles.falseButton}
                  key={`displayChartList-${chart.id}`}
                >
                  <span>{chart.name}</span>
                </Button>
              </Tooltip>
            ))}
            {isCreateCustomCharts && selectedChart === DEFAULT_CUSTOM_CHART_KEY && (
              <Button
                onClick={() => clickPanel(DEFAULT_CUSTOM_CHART_KEY, null, setSelectedChart)}
                component="button"
                sx={DEFAULT_CUSTOM_CHART_KEY === selectedChart ? styles.trueButton : styles.falseButton}
                key={`displayChartList`}
              >
                <span>{customChartTitle}</span>
              </Button>
            )}
          </>
        ) : (
          <Button
            component="button"
            sx={styles.trueButton}
            key={`displayChartList`}
          >
            <span>{customChartTitle}</span>
          </Button>
        )}
        {
          <Box sx={{opacity: displayChartListLength >= 16 ? 0.4 : 1}} key={`displayChartList-${DEFAULT_CUSTOM_CHART_KEY}-default`}>
            <AddButton
              onClickHandler={() => {
                setIsCreateCustomCharts(true);
                clickPanel(DEFAULT_CUSTOM_CHART_KEY, null, setSelectedChart);
              }}
              disabled={displayChartListLength >=16 || (isCreateCustomCharts && selectedChart === DEFAULT_CUSTOM_CHART_KEY)}
              key={`displayChartList-create`}
            />
          </Box>
        }
      </Stack>
    );
  };

  return (
    <Grid
      container
      justifyContent="flex-start"
      direction="row"
      alignItems="center"
      sx={{width: "100%"}}
    >
      {displayChartList()}
    </Grid>
  );
});

CustomGraphSelector.propTypes = {
  selectedChart: PropTypes.string,
  setSelectedChart: PropTypes.func,
  chartList: PropTypes.array,
  isCreateCustomCharts: PropTypes.bool,
  setIsCreateCustomCharts: PropTypes.func,
  customChartTitle: PropTypes.string,
};
